import styled from 'styled-components';

export const Container = styled.div``;

export const Title = styled.h5`
  font-weight: bold;
  text-align: center;
`;

export const Icon = styled.div`
  text-align: center;
  width: 8rem;
  padding: 2rem 0;
  background: #f5f5f5;
  color: #72a49f;
  border-radius: 50%;
  box-shadow: 0 8px 6px -6px #b7b7b7;
  margin: 1.5rem auto;
`;